module.exports = __webpack_public_path__ + "img/diversity.ab3cd99.png";